import React, { useContext, useEffect, useState } from 'react'

import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import OpeningHours from './OpeningHours';
import { Button, Checkbox } from '@mui/material';
import { AddBoxOutlined, RemoveCircleOutline } from '@mui/icons-material';
import InputSet from '../../../../MySections/PopUps/InputSet';
import InputDubleSet from '../../../../MySections/PopUps/InputDubleSet';
import BlockedDateList from './BlockedDateList';

const DeliverMaster = (props) => {
    const [theMaster] = useContext(TheMasterContext);
    const [blockDeliverys, setBlockDeliverys] = useState(theMaster.blockDeliverys);
    const [deliveryHours, setDeliveryHours] = useState(theMaster.availableOrderTimes);
    const [deliveryCitys, setDeliveryCitys] = useState((theMaster.cityesToDeliver != null) ?
        theMaster.cityesToDeliver : [{ city: "", deliveryPrice: "" }]);
    const [thePopUp, setThePopUp] = useState("");

    useEffect(() => {
    }, [])

    const addCityToList = () => {
        setThePopUp(
            <InputDubleSet Title={"הוספת עיר"}
                // ContentText={"שם העיר"}               
                inLabel={"שם העיר"}
                inLabel2={"מחיר למשלוח"}
                okClick={(backData) => addMeTocity(backData)}
                cancelClick={() => setThePopUp()}
                errorMsg={"על מנת ליצור עיר למשלוח, חובה לתת לה שם."}
            />)


    }

    const addMeTocity = (theData) => {
        let tempolst = [...deliveryCitys];
        tempolst.push({ cityName: theData.inputTxt, delivPrice: theData.inputPrc });
        setDeliveryCitys(tempolst);
        theMaster["cityesToDeliver"] = tempolst;

    }

    const changeDelPrice = (newPrice, cityName) => {
        let tempolst = [...deliveryCitys];
        let found = tempolst.findIndex(it => it.cityName === cityName);

        tempolst[found].delivPrice = newPrice;
        setDeliveryCitys(tempolst);
        theMaster["cityesToDeliver"] = tempolst;

    }

    const removeCityFromList = (cityName) => {
        let tempolst = [...deliveryCitys];
        let Filterd = tempolst.filter(it => it.cityName != cityName);

        setDeliveryCitys(Filterd);
        theMaster["cityesToDeliver"] = Filterd;

    }

    const updateHoursDel = (hoursBk) => {
        console.log(hoursBk);
        setDeliveryHours(hoursBk);

        theMaster["availableOrderTimes"] = hoursBk;


    }


    const setBlckDeliverys = () => {
        let temp = { ...blockDeliverys }
        temp.block = !temp.block;
        theMaster["blockDeliverys"] = temp;
        setBlockDeliverys(temp)

    }


    const setDateSpecilsBlocks = (newList) => {
        let temp = { ...theMaster }
        temp.dateSpecilsBlocks = newList;
        theMaster["dateSpecilsBlocks"] = newList;

    }

    return (
        <>
            <div className={"col-md-6 mb-2 grayFrame fullRow"}>
                <label htmlFor={"validationCustom1_6"}>מינימום מחיר הזמנה למשלוח</label>
                <span className={"explanation mediumst fullROw"}>במידה ולא מוגדר מחיר מינימום למשלוח, זה יהיה המינימום מחיר למשלוח </span>
                <div className={"input-group"}>
                    <input type="number" className={"form-control"} id={"minimomForDel"} value={theMaster.MiniDelPrice}
                        onChange={(e) => theMaster["MiniDelPrice"] = e.target.value}
                    />

                </div>

                <div className={"col-md-12 mb-2 "}>
                    <div className={"fullRow spaceMargeBottomnBig"}>
                        <label htmlFor={"validationCustom1_64"}>ערים אפשריות למשלוח</label>
                        <Button className={"btnSPc"} variant="contained" onClick={() => addCityToList()}
                            startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                            הוסף עיר
                        </Button>
                    </div>
                    <div className={"input-group"}>
                        {deliveryCitys.map((itm, indx) => {
                            return (
                                <div key={indx} className='col-md-12 mb-2 fullRow spaceMargeBottomnBig grayLineBoottom'>
                                    <div className={"col-md-6 mb-2 onRight"}>
                                        <RemoveCircleOutline className={"removeBtnMinus onRight"}
                                            onClick={() => removeCityFromList(itm.cityName)} />
                                        <span className='bold onRight spaceMargeRightbig'>{itm.cityName}</span>

                                    </div>

                                    <div className={"col-md-6 mb-2 onRight"}>
                                        <input type="text" className={"form-control"} placeholder={""}
                                            value={itm.delivPrice}
                                            onChange={(e) => { changeDelPrice(e.target.value, itm.cityName) }}
                                        />

                                    </div>
                                </div>

                            )
                        })}
                    </div>

                </div>
            </div >
            <div className={"col-md-6 mb-2 tblHours fullRow grayFrame"}>
                <label className={"fullRow centerText"}>שעות אפשריות לקבלת הזמנה</label>
                <span className={"explanation mediumst fullROw centerText"}>טווח הזמנים לאספקת ההזמנה</span>
                <OpeningHours theHours={deliveryHours}
                    SetTheHours={(hoursBk) => { updateHoursDel(hoursBk) }} />
            </div>
            <div className={"col-md-6 mb-2 onRight grayFrame"}>
                <label htmlFor={"validationCustom1_6"}>חסימת כלל ההזמנות</label>
                <span className={"explanation mediumst fullROw"}>במידה ופעיל, לא יתאפשרו הזמנות</span>
                <label className="ms-switch">
                    <input type="checkbox" id={"validationCustom5_3"} checked={blockDeliverys.block}
                        onChange={(e) => setBlckDeliverys()} />
                    <span className="ms-switch-slider ms-switch-primary round" />
                </label> <span className={"spHead"}>חסימת הזמנות</span>
            </div>
            <div className={"col-md-6 mb-2 tblHours fullRow grayFrame"}>
                <label className={"fullRow centerText"}>תאריכים מיוחדים לחסימה</label>
                {/* <OpeningHours theHours={deliveryHours}
                    SetTheHours={(hoursBk) => { updateHoursDel(hoursBk) }} /> */}
                <BlockedDateList
                    theDates={theMaster.dateSpecilsBlocks || []}
                    SetTheDates={(newLst) => { setDateSpecilsBlocks(newLst) }} />

            </div>

            {thePopUp}
        </>

    );
}

export default DeliverMaster;